import { Sparkles, Store, Headphones, BadgeCheck, ListChecks, MessageSquareQuote, CircleHelp, Ban, Cpu, Globe, LifeBuoy, BookOpen, HeartHandshake, Send, CalendarClock, Phone, Mail } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL } from "@/lib/api";

export const NAV_MENUS = [
  {
    to: "/",
    label: "Home",
    items: [
      { to: "/#welcome", icon: Sparkles, title: "Why 866Zerofees", desc: "Zero fees up front, real people behind you." },
      { to: "/#merchants", icon: Store, title: "For merchants", desc: "In-person, online and omnichannel." },
      { to: "/#support-teams", icon: Headphones, title: "Support teams", desc: "Service, tech, account managers, setup." },
      { to: "/#benefits", icon: BadgeCheck, title: "The Zero difference", desc: "Everything you get when you switch." },
      { to: "/#how-it-works", icon: ListChecks, title: "How it works", desc: "Three simple steps to get started." },
      { to: "/#reviews", icon: MessageSquareQuote, title: "Client reviews", desc: "What our merchants say." },
      { to: "/#faq", icon: CircleHelp, title: "FAQ", desc: "Answers to common questions." },
    ],
  },
  {
    to: "/solutions",
    label: "Solutions",
    items: [
      { to: "/solutions#fee-elimination", icon: Ban, title: "Fee elimination", desc: "Stop paying to accept cards." },
      { to: "/solutions#equipment", icon: Cpu, title: "Equipment", desc: "Free hardware for qualifying merchants." },
      { to: "/solutions#online-payments", icon: Globe, title: "Online payments", desc: "Sell online and over the phone." },
      { to: "/solutions#support", icon: LifeBuoy, title: "Support", desc: "People who pick up the phone." },
    ],
  },
  { to: "/support", label: "Support" },
  {
    to: "/about",
    label: "About",
    items: [
      { to: "/about#our-story", icon: BookOpen, title: "Our story", desc: "Why we started 866Zerofees.com." },
      { to: "/about#values", icon: HeartHandshake, title: "Our values", desc: "Transparency, partnership, service, growth." },
      { to: "/about#reviews", icon: MessageSquareQuote, title: "Client reviews", desc: "What our merchants say." },
    ],
  },
  {
    to: "/contact",
    label: "Contact",
    items: [
      { to: "/contact#contact-form", icon: Send, title: "Send a message", desc: "Your account manager will get back to you." },
      { to: "/contact#book-call", icon: CalendarClock, title: "Book a call", desc: "Pick a time that works for you." },
      { href: PHONE_HREF, icon: Phone, title: "Call us", desc: PHONE },
      { href: `mailto:${EMAIL}`, icon: Mail, title: "Email us", desc: EMAIL },
    ],
  },
];
